import React, { useEffect } from 'react';
import Template from './Template/Template';
import img from 'src/assets/images/lock-v2.svg';
import './BankFailure.scss';
import { STEP_MANUAL, STEP_LANDING, PATH_LINK } from '../AddBank/AddBank';

export const TechnicalBankFailure = ({
  dispatchPageLoad,
  handleClose,
  isSalesForceRep,
  setBankProgress,
  path,
}) => {
  useEffect(() => {
    dispatchPageLoad(
      path === PATH_LINK
        ? `TechnicalBankErrorPlaid`
        : `TechnicalBankErrorManual`
    );
  }, [dispatchPageLoad, path]);
  return (
    <div>
      {!isSalesForceRep && (
        <Template
          image={img}
          header={`We are having technical issues.`}
          msg={
            <div>
              Please try again or{' '}
              <a href="https://www.troweprice.com/personal-investing/help/contact/index.html">
                contact us
              </a>{' '}
              for assistance.
            </div>
          }
          nextButton={`Try Again`}
          onNextClick={() => setBankProgress(STEP_LANDING)}
          backButton={`Cancel`}
          onBackClick={() => handleClose()}
        />
      )}
      {isSalesForceRep && (
        <Template
          image={img}
          header={`We are having technical issues.`}
          msg={
            <div>
              Please try again or{' '}
              <a href="https://www.troweprice.com/personal-investing/help/contact/index.html">
                contact us
              </a>{' '}
              for assistance.
            </div>
          }
          nextButton={`Try Again`}
          onNextClick={() => setBankProgress(STEP_MANUAL)}
        />
      )}
    </div>
  );
};

export default TechnicalBankFailure;
